import React, { Component } from "react";
import Select from "react-select";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import userActions from "../../../_actions/userActions";
import unitActions from "../../../_actions/unitActions";
import distOptions from "../../../_constants/distOptions";
import { docPermConstants } from "../../../_constants/permissionConstants";

class EditUnitModal extends Component {
  state = {
    unitManagerOptions: [],
    parentUnitOptions: [],
    formData: {
      unitId: 0,
      selectedDistrict: null,
      district: "",
      unitNumber: "",
      description: "",
      unitManagerUserId: "",
      selectedUnitManager: null,
      hasSupervisingUnit: false,
      parentUnitId: 0,
      selectedParentUnit: null,
    },
    formErrors: {
      district: null,
      unitNumber: null,
      description: null,
      selectedUnitManager: null,
    },
    errorOnSubmit: null,
  };

  async componentDidMount() {
    const { user, unit, isNewUnit, dispatch, distToPreselect } = this.props;
    let formData = { ...this.state.formData };

    const distToQuery =
      !isNewUnit && unit ? unit.district : distToPreselect || user.unit?.district || 0;
    const [unitManagers, parentUnits] = await Promise.all([
      dispatch(userActions.getAllManagers(distToQuery)),
      dispatch(unitActions.getAll(distToQuery)),
    ]);

    const unitManagerOptions = this.getUnitManagerOptions(unitManagers);
    const parentUnitOptions = this.getParentUnitOptions(parentUnits);

    // Prepopulate values when editing existing unit
    if (!isNewUnit && unit) {
      formData.unitId = unit.unitId;
      formData.district = unit.district;
      formData.selectedDistrict = distOptions.with59.find(
        (d) => d.value === unit.district
      );
      formData.unitNumber = unit.unitNumber;
      formData.description = unit.description;
      formData.hasSupervisingUnit = unit.parentUnitId ? true : false;
      formData.parentUnitId = unit.parentUnitId;
      formData.unitManagerUserId = unit.unitManagerUserId;
      formData.selectedUnitManager = unitManagerOptions.find(
        (o) => o.value === unit.unitManagerUserId
      );
      formData.selectedParentUnit = unit.parentUnitId
        ? parentUnitOptions.find((o) => o.value === unit.parentUnitId)
        : null;
    }
    // Initialize values when creating new unit
    else {
      formData.district = distToPreselect || user.unit?.district;
      formData.selectedDistrict = distOptions.with59.find(
        (d) => d.value === (distToPreselect || (user.unit?.district ?? 0))
      );
    }
    this.setState({ unitManagerOptions, parentUnitOptions, formData });
  }

  getUnitManagerOptions = (umList) =>
    (umList || []).map((u) => ({
      value: u.userId,
      label: u.fullName + " (" + u.userRole.description + ")",
      unitId: u.unit.unitId,
    }));

  getParentUnitOptions = (puList) =>
    (puList || []).map((u) => ({
      value: u.unitId,
      label:
        u.distUnit +
        " - " +
        u.description +
        (u.unitManagerUserId
          ? " (" + u.unitManagerFullName + ")"
          : " (Unit Manager N/A)"),
    }));

  handleChange_editUnitForm = (e) => {
    const { name, value } = e.target;
    const formData = { ...this.state.formData };
    formData[name] = value;
    this.setState({ formData });
  };

  handleChange_hasSupervisingUnit = (e) => {
    const formData = { ...this.state.formData };
    formData.hasSupervisingUnit = e.target.checked;
    this.setState({ formData });
  };

  handleChange_select = (fieldName, optionFieldName) => async (selectedOption) => {
    const { dispatch } = this.props;
    const formData = { ...this.state.formData };
    formData[fieldName] = selectedOption ? selectedOption.value : null;
    formData[optionFieldName] = selectedOption || null;

    // Special case for district selector (note, the district selector is
    // only enabled for system admins when creating a new unit.)
    if (fieldName === "district" && selectedOption) {
      // Clear the unit manager selector after selecting a new district.
      formData.unitManagerUserId = 0;
      formData.selectedUnitManager = null;
      formData.parentUnitId = 0;
      formData.selectedParentUnit = null;

      // Repopulate the unit manager and parent unit options
      const [unitManagers, parentUnits] = await Promise.all([
        dispatch(userActions.getAllManagers(selectedOption.value)),
        dispatch(unitActions.getAll(selectedOption.value)),
      ]);
      const unitManagerOptions = this.getUnitManagerOptions(unitManagers);
      const parentUnitOptions = this.getParentUnitOptions(parentUnits);

      this.setState({ formData, unitManagerOptions, parentUnitOptions }, () =>
        this.validateForm(optionFieldName)
      );
    } else this.setState({ formData }, () => this.validateForm(optionFieldName));
  };

  handleBlur = (e) => this.validateForm(e.target.name);
  handleBlur_select = (fieldName) => () => this.validateForm(fieldName);

  disableSelfFromParentUnit = (option) => {
    const { isNewUnit, unit } = this.props;
    if (!isNewUnit && unit && option.value === unit.unitId) return true;
    return false;
  };

  validateForm = (fieldName) => {
    const { formData } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "district":
        if (formData.district == null) formErrors.district = "Required";
        else formErrors.district = null;
        break;
      case "unitNumber":
        if (formData.unitNumber === "") formErrors.unitNumber = "Required";
        else formErrors.unitNumber = null;
        break;
      case "description":
        if (formData.description === "") formErrors.description = "Required";
        else formErrors.description = null;
        break;
      case "unitManager":
        if (formData.selectedUnitManager == null)
          formErrors.selectedUnitManager = "Required";
        else formErrors.selectedUnitManager = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  formIsIncomplete = () => {
    const { district, unitNumber, description } = this.state.formErrors;
    const { formData } = this.state;
    if (
      district ||
      unitNumber ||
      description ||
      formData.district === "" ||
      formData.unitNumber === "" ||
      formData.description === ""
    )
      return true;
    else return false;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const formData = { ...this.state.formData };
    const { dispatch, isNewUnit, toggleEditUnitModal, submitCallback, tabId } =
      this.props;
    if (!this.formIsIncomplete()) {
      if (!formData.selectedUnitManager) formData.unitManagerUserId = null;
      if (!formData.hasSupervisingUnit) formData.parentUnitId = null;
      if (isNewUnit) {
        await dispatch(unitActions.add(formData, tabId));
        submitCallback && submitCallback();
        toggleEditUnitModal();
      } else {
        await dispatch(unitActions.update(formData, tabId));
        submitCallback && submitCallback();
        toggleEditUnitModal();
      }
    }
  };

  handleClick_cancel = (e) => {
    e.preventDefault();
    this.props.toggleEditUnitModal();
  };

  render() {
    const { formData, formErrors, unitManagerOptions, parentUnitOptions } = this.state;
    const { showEditUnitModal, toggleEditUnitModal, isNewUnit, permissions, fetching } =
      this.props;
    const closeBtn = (
      <button className="close" onClick={toggleEditUnitModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );

    return (
      <React.Fragment>
        <Modal
          isOpen={showEditUnitModal}
          toggle={toggleEditUnitModal}
          className={this.props.className}
          size={"lg"}
          fade={false}
        >
          <ModalHeader
            toggle={toggleEditUnitModal}
            className="bg-info text-white"
            close={closeBtn}
          >
            {isNewUnit ? (
              <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
            ) : (
              <FontAwesomeIcon icon="edit" className="fa-fw mr-2" />
            )}
            {isNewUnit ? "Add Unit" : "Edit Unit Information"}
          </ModalHeader>
          <ModalBody>
            <form name="addUnit">
              <div className="card m-2">
                <div className="card-body">
                  <div className="form-row form-group">
                    <label
                      htmlFor="district"
                      className="col-md-4 col-lg-3 col-form-label"
                    >
                      <b>District:</b>*
                    </label>
                    <div className="col-sm-8 col-md-6 col-lg-4">
                      <Select
                        name="district"
                        id="district"
                        className="align-middle px-0"
                        value={formData.selectedDistrict}
                        options={distOptions.with59}
                        onChange={this.handleChange_select(
                          "district",
                          "selectedDistrict"
                        )}
                        onBlur={this.handleBlur_select("district")}
                        placeholder="Dist"
                        isSearchable={false}
                        isDisabled={
                          !permissions.includes(docPermConstants.EDIT_LEVEL_2) ||
                          !isNewUnit
                        }
                        styles={{
                          // Fixes the overlapping problem of the component
                          menu: (provided) => ({ ...provided, zIndex: 9999 }),
                        }}
                      />
                      {formErrors.district && (
                        <span className="error-small">
                          <small>{formErrors.district}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group">
                    <label
                      htmlFor="unitNumber"
                      className="col-md-4 col-lg-3 col-form-label"
                    >
                      <b>Unit No.:</b>* <small>(4-d EFIS)</small>
                    </label>
                    <div className="col-sm-8 col-md-6 col-lg-4">
                      <input
                        type="text"
                        name="unitNumber"
                        id="unitNumber"
                        maxLength="4"
                        className="form-control"
                        value={formData.unitNumber}
                        onChange={this.handleChange_editUnitForm}
                        onBlur={this.handleBlur}
                      />
                      {formErrors.unitNumber && (
                        <span className="error-small">
                          <small>{formErrors.unitNumber}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group">
                    <label
                      htmlFor="description"
                      className="col-md-4 col-lg-3 col-form-label"
                    >
                      <b>Description:</b>*
                    </label>
                    <div className="col-md-8 col-lg-9">
                      <input
                        type="text"
                        name="description"
                        id="description"
                        className="form-control"
                        maxLength="400"
                        value={formData.description}
                        onChange={this.handleChange_editUnitForm}
                        onBlur={this.handleBlur}
                      />
                      {formErrors.description && (
                        <span className="error-small">
                          <small>{formErrors.description}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group">
                    <label
                      htmlFor="unitManager"
                      className="col-md-4 col-lg-3 col-form-label"
                    >
                      Unit Manager:
                    </label>
                    <div className="col-md-8 col-lg-9">
                      <Select
                        name="unitManager"
                        id="unitManager"
                        value={formData.selectedUnitManager}
                        options={unitManagerOptions}
                        onChange={this.handleChange_select(
                          "unitManagerUserId",
                          "selectedUnitManager"
                        )}
                        onBlur={this.handleBlur_select("selectedUnitManager")}
                        isClearable
                        styles={{
                          // Fixes the overlapping problem of the component
                          menu: (provided) => ({ ...provided, zIndex: 9999 }),
                        }}
                      />
                      {formErrors.selectedUnitManager && (
                        <span className="error-small">
                          <small>{formErrors.selectedUnitManager}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-body bg-lightgray">
                      <h5 className="text-muted">Unit Hierarchy (Optional)</h5>
                      <div className="form-row">
                        <div className="form-check-inline custom-control custom-checkbox my-auto ml-1">
                          <input
                            type="checkbox"
                            name="hasSupervisingUnit"
                            id="hasSupervisingUnit"
                            className="custom-control-input"
                            checked={formData.hasSupervisingUnit}
                            onChange={this.handleChange_hasSupervisingUnit}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="hasSupervisingUnit"
                          >
                            Has a supervising unit:
                          </label>
                        </div>
                        <div className="col-sm-12 col-md-7">
                          <Select
                            name="parentUnit"
                            id="parentUnit"
                            value={formData.selectedParentUnit}
                            options={parentUnitOptions}
                            isOptionDisabled={(option) =>
                              this.disableSelfFromParentUnit(option)
                            }
                            onChange={this.handleChange_select(
                              "parentUnitId",
                              "selectedParentUnit"
                            )}
                            isDisabled={!formData.hasSupervisingUnit}
                            isClearable
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-row form-group float-right mr-2 mb-0">
              <button
                type="submit"
                name="submitAddUnitForm"
                id="submitAddUnitForm"
                className="btn btn-primary mr-2"
                onClick={this.handleSubmit}
                disabled={this.formIsIncomplete() || fetching}
              >
                {fetching && (
                  <span className="mr-2 mt-1">
                    <FontAwesomeIcon
                      icon="spinner"
                      className="loading-spinner"
                      style={{ color: "white" }}
                    />
                  </span>
                )}
                {`${
                  isNewUnit
                    ? fetching
                      ? "Adding"
                      : "Add Unit"
                    : fetching
                    ? "Saving"
                    : "Save"
                }`}
              </button>
              <button
                type="button"
                name="cancelAddUnit"
                id="cancelAddUnit"
                className="btn btn-secondary"
                onClick={toggleEditUnitModal}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.authentication.user,
  fetching: state.users.fetching,
});

export default connect(mapStateToProps)(EditUnitModal);
